<template>
   <tr>
    <td >
      <router-link :to="displayCandidateHistoric()" target="_blank">
        {{ candidate.first_name }} {{ candidate.last_name }}
      </router-link>
    </td>

    <td>
      <div v-if="affiliated_service.length > 0 ">
        <services-grouped-by-hubs :services="affiliated_service"
                                  :hubs="hubs"
                                  :shortened="true" />
      </div>
    </td>

    <td class="number-info text-center">
      {{  effectiveWork(candidate.effective_work_minutes.week) }}
    </td>

    <td class="number-info text-center">
      {{ effectiveWork(candidate.effective_work_minutes.month) }}
    </td>

    <td class="number-info text-center">
      {{ effectiveWork(candidate.effective_work_minutes.year) }}
    </td>

    <td class="text-center">
      <input type="checkbox" v-model="checked" :id="candidate.id" :value="candidate.id" @input="updateCheckedValue">
    </td>
  </tr>
</template>

<script type="text/javascript">
import { mapGetters, mapActions } from 'vuex'
import { convertMinutesToDurationTime } from '@/helpers/timeCodes'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: 'CandidateRow',
    props: ['candidate', 'checkAllCandidates', 'checkCandidateIds', 'entityId'],
    data() {
      return {
        checked: false
      }
    },
    components: { ServicesGroupedByHubs },
    computed: {
      ...mapGetters({
        potentialCandidatesIds: 'offers/candidatesIdsList',
      }),
      affiliated_service() {
        if(this.candidate.affiliated_service){
          return [this.candidate.affiliated_service]
        }

        return []
      },
      hubs() {
        if(!this.candidate || !this.candidate.entities || this.candidate.entities.length == 0) {
          return []
        }
        const entity = this.candidate.entities.find((entity) => entity.id == this.entityId)
        if(!entity) {
          return []
        }

        return entity.hubs
      }
    },
    watch: {
      checkAllCandidates() {
        const candidateIds = Object.keys(this.checkCandidateIds).map(id => parseInt(id))
        if (candidateIds.includes(this.candidate.id)) {
          this.checked = this.checkCandidateIds[this.candidate.id]
        } else {
          this.checked = this.candidate.potential_candidate
        }
      }
    },
    methods: {
      ...mapActions({
        loadUnavailabilityDateCount: 'unavailabilityDates/loadUnavailabilityDateCount',
      }),
      effectiveWork(time){
        return convertMinutesToDurationTime(time, false)
      },
      updateCheckedValue(e) {
        this.$emit('updateCheckedValue', {userId: this.candidate.id, checked: e.target.checked})
      },
      displayCandidateHistoric: function() {
        return {
          name: "CandidatePlanning",
          params: { entity_id: this.entityId, user_id: this.candidate.id }
        }
      },
    },
    mounted: function() {
      if (this.checkCandidateIds[this.candidate.id] == undefined) {
        this.checked = this.potentialCandidatesIds[this.candidate.id]
      } else {
        this.checked = this.checkCandidateIds[this.candidate.id]
      }
    }
  }
</script>
<style lang="scss" scoped>
  .table tbody tr td {
    padding: 16px 8px;
  }
 .number-info {
    background-color: #eff9f7 !important;
  }

  tr:nth-child(even) td{
    background-color: #f7f7f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/offers/CandidateRow.vue